<div class="ui modal"
     id="BarcodeCardModal"
     style="position:absolute;left:35%;bottom:15%">
  <div class="header"
       style="display:flex;">
    <div style="background-color:black;width:85%;color:white;border-radius: 4px;display: flex;align-items: center;">
      <span style="margin-left:10px" tkey="Login"></span>
    </div>
    <div style="background-color:black;width:15%;margin-left:10px;border-radius: 4px;display: flex; align-items: center;">
      <button style="float:right;background-color:black;color:white;width:100%"
              class="ui icon button"
              (click)="ModalClose()">
        <i class="remove link icon"></i>
      </button>
    </div>
  </div>


  <div class="content">
    <div class="ui fluid input focus">
      <input placeholder="{{IsFirst ? 'Aktuel PIN' : 'PIN'}} "
             id="Input_1_Value"
             style="height:55px;font-size:22px;background-color:gainsboro"
             type="password"
             (focus)="onFocusEvent('Input_1')"
             [(ngModel)]="this.Input_1_Value">
    </div>
  </div>
  <ng-container *ngIf="IsFirst">
    <div class="content">
      <div class="ui fluid input">
        <input placeholder="Neue PIN"
               id="Input_2_Value"
               style="height:55px;font-size:22px;background-color:gainsboro"
               type="password"
               (focus)="onFocusEvent('Input_2')"
               [(ngModel)]="this.Input_2_Value"/>
      </div>
    </div>
  </ng-container>


  <div *ngIf="ResultCode < 0"  style="color:red;text-align:center;font-weight: bold">
    {{ResultMessage}}
  </div>

  <div *ngIf="ResultMessage2 != ''" style="color:red;text-align:center;font-weight: bold">
    <span>
      {{ ResultMessage2 | t }}
    </span>
  </div>


  <div class="inline field"
       style="text-align: center;color:red;">
    <span *ngIf="this.tournamentsService.SettingPasswordErrorVisible==1">{{this._translate.getT("Password_is_incorrect")}}</span>
  </div>
  <div class="content">
    <div class="ui grid segment"
         style="height:412px;background-color:gainsboro;">
      <table class="ui table"
             id="SettingPasswordLogin_Modal_ButtonTable"
             style="background-color:gainsboro;">
        <tr>
          <td class="four wide">
            <button class="SettingLoginButton"
                    (click)="BarcodeCard_ChangeValue(1)">1
            </button>
          </td>
          <td class="four wide">
            <button class="SettingLoginButton"
                    (click)="BarcodeCard_ChangeValue(2)">2
            </button>
          </td>
          <td class="four wide">
            <button class="SettingLoginButton"
                    (click)="BarcodeCard_ChangeValue('3')">3
            </button>
          </td>
          <td rowspan="2"
              class="four wide">
            <button class="ui fluid icon button"
                    style="height:170px;width:70px;background:black;color:white;"
                    (click)="SettingLogin__Cancel()">
              <i class="big arrow left icon"></i>
            </button>
          </td>
        </tr>
        <tr>
          <td class="four wide">
            <button class="SettingLoginButton"
                    (click)="BarcodeCard_ChangeValue(4)">4
            </button>
          </td>
          <td class="four wide">
            <button class="SettingLoginButton"
                    (click)="BarcodeCard_ChangeValue(5)">5
            </button>
          </td>
          <td class="four wide">
            <button class="SettingLoginButton"
                    (click)="BarcodeCard_ChangeValue(6)">6
            </button>
          </td>
        </tr>
        <tr>
          <td class="four wide">
            <button class="SettingLoginButton"
                    (click)="BarcodeCard_ChangeValue(7)">7
            </button>
          </td>
          <td class="four wide">
            <button class="SettingLoginButton"
                    (click)="BarcodeCard_ChangeValue(8)">8
            </button>
          </td>
          <td class="four wide">
            <button class="SettingLoginButton"
                    (click)="BarcodeCard_ChangeValue(9)">9
            </button>
          </td>
          <td rowspan="2"
              class="four wide">
            <button class="ui fluid button"
                    style="height:170px;width:70px;background:black;color:white;"
                    (click)="BarcodeCardOk()">
              OK
            </button>
          </td>
        </tr>
        <tr style="height:102px">
          <td></td>
        </tr>

      </table>
      <button class="SettingLoginButton"
              style="color:white;width:286px; height: 71px;position:relative;bottom: 103px;margin-left:10px;"
              (click)="BarcodeCard_ChangeValue(0)">
        0
      </button>
    </div>
  </div>
</div>
